import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { push } from "connected-react-router";
import downloadFile from "../../../lib/utils/downloadFile";
import ModalActions from "../../../redux/reducers/modal.reducer";
import theme from "../../../styles/LightTheme";
import App from "lib/app";

/**
 * Hook para manejar acciones del historial de pagos.
 * Centraliza navegación y descarga de derechos patrimoniales.
 */
export const usePaymentHistoryActions = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleBack = useCallback(() => {
    dispatch(push("/my-payments"));
  }, [dispatch]);

  const handleDownload = useCallback(
    async (payment) => {
      dispatch(
        ModalActions.setConditionalModalState(true, "ModalLoadingCertificate", {
          clearBlur: true,
          css: { backgroundColor: theme.transparentMartinique },
          description: t("searchInvestDetail.download")
        })
      );

      try {
        const data = await App.api.a2censo.getPaymentDownloadUrl({
          url: { issuerPaymentId: payment.id }
        });
        dispatch(
          ModalActions.setConditionalModalState(
            false,
            "ModalLoadingCertificate"
          )
        );
        downloadFile(data.signed_url || data["signed-url"], false);
      } catch {
        dispatch(
          ModalActions.setConditionalModalState(
            false,
            "ModalLoadingCertificate"
          )
        );
        dispatch(
          ModalActions.setConditionalModalState(true, "ErrorModal", {
            title: "Error",
            content: "No se pudo generar y descargar el archivo"
          })
        );
      }
    },
    [dispatch, t]
  );

  return {
    handleBack,
    handleDownload
  };
};
